import React, { useEffect, useState } from 'react'
import { makeStyles } from '@material-ui/core/styles'
import { Typography, Button } from 'foundations-library/components'
import Grid from '@material-ui/core/Grid'
import { useHistory } from 'react-router-dom'
import { processLink } from './../../../utils/utils'
import { Articles } from './howTo/articles/Index'
import { App } from './../../../utils/objects'
import { useWidgetContext } from 'providers'
import { FeatureType } from 'widgets'

const useStyles = makeStyles(theme => ({
    articlesRoot: {
        rowGap: '.5rem'
    }
}))

/**
 *
 */
const HowToArticles = ({ app }: { app: App }) => {
    const classes = useStyles()
    const history = useHistory()

    const { findSectionBySlug, remoteValue } = useWidgetContext()
    const [articles, setArticles] = useState<FeatureType[]>([])
    useEffect(() => {
        const section = findSectionBySlug('esim')
        if (section) {
            setArticles(section.articles || [])
        }
    }, [remoteValue])

    return (
        <Grid container xs={12} direction='column' className={classes.articlesRoot}>
            <Typography variant='h6'>Top How-to-articles</Typography>
            <Articles articles={articles.slice(0, 3)} />
            <Button color='secondary' iconLeft={false} icon='go' variant='text' onClick={() => processLink('/how-to-articles', history, true)}>View all how-to-articles</Button>
        </Grid>
    )
}

export default HowToArticles
